import { loginInstance } from ".";

export const USER_LOGIN = async ({ userName, password }) => {
  const user_creds = { userName, password };
  const url = `/api/v1/auth/login-username`;
  const response = await loginInstance.post(url, user_creds);
  return response.data;
};

/* Fetch new access_token and refresh_token using refresh_token */
export const TOKEN_REFRESH = async (refreshToken) => {
  const url = `/api/v1/auth/refresh-token`;
  const response = await loginInstance.post(
    url,
    {},
    {
      headers: {
        "Refresh-Token": refreshToken,
      },
    }
  );

  return response.data;
};

/*logs out a certain user on by passing its refresh token as parameter*/
export const USER_LOGOUT = async (token) => {
  const url = `/api/v1/auth/logout`;
  const response = await loginInstance.post(
    url,
    {},
    {
      headers: {
        "Refresh-Token": token,
      },
    }
  );
  return response.data;
};

/*Gets user profile details using access_token as parameter*/
export const USER_PROFILE = async (auth_token) => {
  const url = `/api/v1/userrs/profile`;
  const response = await loginInstance.get(url, {
    headers: {
      clientId: process.env.NEXT_PUBLIC_CLIENT_ID,
    },
  });
  return response.data;
};

/*Get user access module*/
export const USER_MODULES = async (auth_token) => {
  const url = `/api/v1/userrs/modules-permissions`;
  const response = await loginInstance.get(url, {
    headers: {
      clientId: process.env.NEXT_PUBLIC_CLIENT_ID,
    },
  });
  return response.data;
};

export const passwordExpiredGenerateOTP = async (postBody) => {
  // Constructing the API URL
  const url = `/api/v2/auth/password-expired/generate-otp`;
  // Sending the POST request to the API
  const response = await loginInstance.post(url, postBody);
  return response.data;
};

export const passwordExpiredChangePassword = async (postBody) => {
  // Constructing the API URL
  const url = `/api/v2/auth/password-expired/change-password`;

  // Sending the POST request to the API
  const response = await loginInstance.post(url, postBody);
  return response.data;
};
//forgot password otp generate
export const forgotPasswordGenerateOTP = async (postBody) => {
  const url = `/api/v2/auth/forgot-password/generate-otp`;
  const response = await loginInstance.post(url, postBody);
    return response.data;
};
export const forgotPasswordVerifyOTP = async (postBody) => {
  const url = `/api/v2/auth/forgot-password/reset-password`;
  const response = await loginInstance.post(url, postBody);
    return response.data;
};
//otp generation while changing password
export const changePasswordGenerateOTP = async (postBody) => {
  const url = `/api/v1/userrs/password-change/generate-otp`;
  const response = await loginInstance.post(url, postBody, {
    headers: {
      clientId: `${process.env.NEXT_PUBLIC_CLIENT_ID}`,
    },
  });
    return response.data;
};
//OTP verification while changing password
export const changePasswordVerifyOTP = async (postBody) => {
  const url = `/api/v1/userrs/password-change/change-password`;
  const response = await loginInstance.post(url, postBody, {
    headers: {
      clientId: `${process.env.NEXT_PUBLIC_CLIENT_ID}`,
    },
  });
    return response.data;
};

export const firstTimeResetPasswordGenerateOTP = async (postBody) => {
  // Sending the POST request to the API
  const response = await loginInstance.post('/api/v2/auth/first-time-password-reset/otp',
    {
      ...postBody,
      clientId: `${process.env.NEXT_PUBLIC_CLIENT_ID}`,
    }
  );

    return response.data;
};

export const passwordResetPassword = async (postBody) => {
    // Sending the POST request to the API
    const response = await loginInstance.post(`/api/v2/auth/first-time-password-reset/confirm`,{
        ...postBody,
        clientId: `${process.env.NEXT_PUBLIC_CLIENT_ID}`,
      }
    );
      return response.data;
};
